import {
  InstrumentStatus,
  type PaymentInstrument,
} from '@foundation/apis/payments';

import { InputRadioOption } from '@/components/common/forms/inputs/RadioGroup';
import { PaymentIntentFlow } from '@/schemas/PaymentIntent';
import { type IManagePaymentInstrument } from '@/services/payments/instruments/MandateReference';
import PaymentStore from '@/services/payments/PaymentStore';
import { isMpmSepa } from '@/services/payments/utils/InstrumentUtils';

import { ManageStoredInstrument } from './ManageStoredInstrument';
import { StoredInstrument } from './StoredInstrument';

export function computeRadioOptions(
  instruments: ReadonlyArray<IManagePaymentInstrument>,
): InputRadioOption[] {
  const isManageFlow = PaymentStore.flow === PaymentIntentFlow.Manage;

  return instruments.map((instrument) => ({
    id: instrument.id,
    label: isManageFlow ? (
      <ManageStoredInstrument {...instrument} />
    ) : (
      <StoredInstrument {...instrument} />
    ),
    value: instrument.id,
    disabled: instrument.status !== InstrumentStatus.Valid,
  }));
}

export function isDeletable(instrument: PaymentInstrument) {
  return (
    instrument.mandateReference !== undefined || !isMpmSepa(instrument.moduleId)
  );
}
